import { render, staticRenderFns } from "./DoYouWantToChangeVolumeModal.vue?vue&type=template&id=5f2d24dc&scoped=true&"
import script from "./DoYouWantToChangeVolumeModal.vue?vue&type=script&lang=js&"
export * from "./DoYouWantToChangeVolumeModal.vue?vue&type=script&lang=js&"
import style0 from "./DoYouWantToChangeVolumeModal.vue?vue&type=style&index=0&id=5f2d24dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d24dc",
  null
  
)

export default component.exports